import { CateringTranslations } from "./catering-pt-br";

export const CATERING_EN_US: CateringTranslations = {
	title: "Catering",
	description:
		"Manage your events catering, receive proposals, send quotes and monitor everything in one place.",
};
